import React from "react";
import { Alert, Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import { useHistory } from "react-router-dom";
import { BILLING_PATH } from "../../../router/RouterUtils";

interface BannerProps {
  children?: React.ReactNode;
  showsIcon?: boolean;
}

/*
 * Banner for an overdue invoice
 */

export const InvoiceNonpaymentBanner = ({ children, showsIcon }: BannerProps) => {
  const history = useHistory();

  return (
    <Alert
      className="rounded-none z-10"
      color="red"
      showWarningIcon={showsIcon}
      buttons={
        <Button
          size="sm"
          onClick={() => history.push(BILLING_PATH)}
          variant={ButtonVariant.TertiaryWhite}
        >
          Make payment
        </Button>
      }
    >
      <Text>{children}</Text>
    </Alert>
  );
};
